"use client";

import type { ReactNode } from "react";
import { MetaTags, ScrollRestoration } from "@rangojs/router/client";
import styles from "./index.css?url";
/* -- HRM ---  */
import "./index.css";
/* ^ for HRM  */

export function Document({ children }: { children: ReactNode }) {
  return (
    <html lang="en">
      <head>
        <link rel="preconnect" href="/" />
        <link rel="preload" href={styles} as="style" precedence="high" />
        <link rel="stylesheet" href={styles} precedence="high" />
        <MetaTags />
        <ScrollRestoration />
      </head>
      <body className="font-sans antialiased text-slate-900 bg-white">{children}</body>
    </html>
  );
}
